import type { MapSelectionContext } from '../mapSelection'

import { snapshot } from 'valtio'

import { mapSelectionAtom } from '../mapSelection'

export function getMapSelectionContext(): MapSelectionContext {
  return snapshot(mapSelectionAtom.context)
}
